module.exports = __webpack_public_path__ + "static/media/preview_teams.8b98f68b.PNG";